import { render } from "./EndFooter.vue?vue&type=template&id=7d9203c0&scoped=true"
import script from "./EndFooter.vue?vue&type=script&lang=js"
export * from "./EndFooter.vue?vue&type=script&lang=js"

import "./EndFooter.vue?vue&type=style&index=0&id=7d9203c0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\aryav\\Desktop\\Don't touch this file\\Talreq\\talreq\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d9203c0"]])

export default __exports__